import { PasscodeActionConfigMap } from 'state/passcodeConfig';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { PasscodeBusinessConfig } = protos;

/**
 * Update the current business's passcode configuration.
 */
export function update(
  passcodesEnabled: boolean,
  actionConfigMap: PasscodeActionConfigMap
): ApiAction {
  const request = PasscodeBusinessConfig.fromObject({
    passcodeMode: passcodesEnabled ? 'ENABLED' : 'DISABLED',
    actionConfig: Object.values(actionConfigMap),
  });

  return {
    TockApi: {
      postProto: '/admin/business/passcode/config',
      type: AppConstants.PASSCODE_CONFIG_UPDATE,
      request,
      toast: 'Passcode configuration updated',
    },
  };
}

/**
 * Fetch the passcode configuration for the current business.
 */
export function fetchPasscodeConfig(): ApiAction {
  return {
    TockApi: {
      getProto: '/admin/business/passcode/config',
      type: AppConstants.PASSCODE_CONFIG_FETCH,
    },
  };
}
